// keep consistent with cloudtrucks.queryengine.constants.SUPPORTED_STATES
export const US_STATES = [
  { name: 'Alabama', abbreviation: 'AL' },
  { name: 'Alaska', abbreviation: 'AK', isNonContiguousState: true },
  { name: 'Arizona', abbreviation: 'AZ' },
  { name: 'Arkansas', abbreviation: 'AR' },
  { name: 'California', abbreviation: 'CA' },
  { name: 'Colorado', abbreviation: 'CO' },
  { name: 'Connecticut', abbreviation: 'CT' },
  { name: 'Delaware', abbreviation: 'DE' },
  { name: 'District Of Columbia', abbreviation: 'DC' },
  { name: 'Florida', abbreviation: 'FL' },
  { name: 'Georgia', abbreviation: 'GA' },
  { name: 'Hawaii', abbreviation: 'HI', isNonContiguousState: true },
  { name: 'Idaho', abbreviation: 'ID' },
  { name: 'Illinois', abbreviation: 'IL' },
  { name: 'Indiana', abbreviation: 'IN' },
  { name: 'Iowa', abbreviation: 'IA' },
  { name: 'Kansas', abbreviation: 'KS' },
  { name: 'Kentucky', abbreviation: 'KY' },
  { name: 'Louisiana', abbreviation: 'LA' },
  { name: 'Maine', abbreviation: 'ME' },
  { name: 'Maryland', abbreviation: 'MD' },
  { name: 'Massachusetts', abbreviation: 'MA' },
  { name: 'Michigan', abbreviation: 'MI' },
  { name: 'Minnesota', abbreviation: 'MN' },
  { name: 'Mississippi', abbreviation: 'MS' },
  { name: 'Missouri', abbreviation: 'MO' },
  { name: 'Montana', abbreviation: 'MT' },
  { name: 'Nebraska', abbreviation: 'NE' },
  { name: 'Nevada', abbreviation: 'NV' },
  { name: 'New Hampshire', abbreviation: 'NH' },
  { name: 'New Jersey', abbreviation: 'NJ' },
  { name: 'New Mexico', abbreviation: 'NM' },
  { name: 'New York', abbreviation: 'NY' },
  { name: 'North Carolina', abbreviation: 'NC' },
  { name: 'North Dakota', abbreviation: 'ND' },
  { name: 'Ohio', abbreviation: 'OH' },
  { name: 'Oklahoma', abbreviation: 'OK' },
  { name: 'Oregon', abbreviation: 'OR' },
  { name: 'Pennsylvania', abbreviation: 'PA' },
  { name: 'Rhode Island', abbreviation: 'RI' },
  { name: 'South Carolina', abbreviation: 'SC' },
  { name: 'South Dakota', abbreviation: 'SD' },
  { name: 'Tennessee', abbreviation: 'TN' },
  { name: 'Texas', abbreviation: 'TX' },
  { name: 'Utah', abbreviation: 'UT' },
  { name: 'Vermont', abbreviation: 'VT' },
  { name: 'Virginia', abbreviation: 'VA' },
  { name: 'Washington', abbreviation: 'WA' },
  { name: 'West Virginia', abbreviation: 'WV' },
  { name: 'Wisconsin', abbreviation: 'WI' },
  { name: 'Wyoming', abbreviation: 'WY' },
]

// DAT Zip Zones https://www.dat.com/site/assets/files/5174/dat-zip-zone-directory.pdf
export const ZIP_ZONE_STATES = [
  {
    id: 'z0',
    name: 'NorthEast',
    state_ids: ['CT', 'ME', 'MA', 'NH', 'NJ', 'RI', 'VT'],
  },
  {
    id: 'z1',
    name: 'MidNorthEast',
    state_ids: ['DE', 'NY', 'PA'],
  },
  {
    id: 'z2',
    name: 'CentralEast',
    state_ids: ['MD', 'NC', 'SC', 'VA', 'WV'],
  },
  {
    id: 'z3',
    name: 'SouthEast',
    state_ids: ['AL', 'FL', 'GA', 'MS', 'TN'],
  },
  {
    id: 'z4',
    name: 'GreatLakesEast',
    state_ids: ['IN', 'KY', 'MI', 'OH'],
  },
  {
    id: 'z5',
    name: 'NorthCentral',
    state_ids: ['IA', 'MN', 'MT', 'ND', 'SD', 'WI'],
  },
  {
    id: 'z6',
    name: 'Central',
    state_ids: ['IL', 'KS', 'MO', 'NE'],
  },
  {
    id: 'z7',
    name: 'CentralSouth',
    state_ids: ['AR', 'LA', 'OK', 'TX'],
  },
  {
    id: 'z8',
    name: 'SouthWest',
    state_ids: ['AZ', 'CO', 'ID', 'NV', 'NM', 'UT', 'WY'],
  },
  {
    id: 'z9',
    name: 'WestCoast',
    state_ids: ['CA', 'OR', 'WA'],
  },
]

export const CANADIAN_PROVINCES = [
  { name: 'Alberta', abbreviation: 'AB' },
  { name: 'British Columbia', abbreviation: 'BC' },
  { name: 'Manitoba', abbreviation: 'MB' },
  { name: 'New Brunswick', abbreviation: 'NB' },
  { name: 'Newfoundland and Labrador', abbreviation: 'NL' },
  { name: 'Northwest Territories', abbreviation: 'NT' },
  { name: 'Nova Scotia', abbreviation: 'NS' },
  { name: 'Nunavat Territory', abbreviation: 'NU' },
  { name: 'Ontario', abbreviation: 'ON' },
  { name: 'Prince Edward Island', abbreviation: 'PE' },
  { name: 'Quebec', abbreviation: 'QC' },
  { name: 'Saskatchewan', abbreviation: 'SK' },
  { name: 'Yukon Territory', abbreviation: 'YT' },
]

export const getStateChoices = (states: any) => {
  return states.map((value: any) => ({ id: value.abbreviation, name: value.name }))
}
